export default __webpack_public_path__ + "static/media/bandeira_uk.43a5931b.png";